// Existing calculator: paulsen_blog_v01/apps/systemwettenrechner/index.html,
// currentPayload / setFromPayload. No system pricing or combination math here.
export const SYSTEM_CALCULATOR_URL =
  "https://paulsen.blog/apps/systemwettenrechner/index.html";
export function systemBetPayload(tips, profile, k, stakePerCombination) {
  if (
    !Number.isInteger(k) ||
    k < 2 ||
    k > tips.length ||
    tips.length > 20 ||
    !(stakePerCombination > 0)
  )
    throw new Error("INVALID_SYSTEM");
  if (new Set(tips.map((t) => t.fixtureId)).size !== tips.length)
    throw new Error("ONE_SELECTION_PER_FIXTURE");
  if (
    tips.some(
      (t) => !["1x2", "over-under", "asian-handicap"].includes(t.market)
    )
  )
    throw new Error("UNSUPPORTED_SYSTEM_MARKET");
  if (
    tips.some(
      (t) =>
        t.market === "asian-handicap" ||
        t.market === "btts" ||
        (t.market === "over-under" && !Number.isInteger(Number(t.line) * 2))
    )
  ) {
    throw new Error("CALCULATOR_SETTLEMENT_NOT_COMPATIBLE");
  }
  return {
    n: tips.length,
    k,
    stake: stakePerCombination,
    tax: 0,
    vorsteuer: false,
    view: "pro",
    entryMode: "fair",
    basis: "fair",
    betty: {
      version: 1,
      budget: profile.budget,
      maxTotalStake: profile.maxTotalStake,
      quoteBasis: "suggested-not-confirmed",
    },
    rows: tips.map((t) => ({
      type: "spiele",
      home: t.homeTeam.name,
      away: t.awayTeam.name,
      ko: t.kickoff,
      mkt: {
        "1x2": "1X2",
        "over-under": "over_under",
        "asian-handicap": "asian_handicap",
      }[t.market],
      tip:
        t.selection === "home"
          ? "1"
          : t.selection === "away"
          ? "2"
          : t.selection,
      // The calculator treats AH line from the selected team's perspective.
      line: t.line ?? "",
      odds: t.actualOdd ?? t.marketOdd,
      fair: t.fairOdd,
      state: "-1",
      bettyFixtureId: t.fixtureId,
      bettyTipId: t.id,
    })),
  };
}
export function downloadSystem(payload) {
  const url = URL.createObjectURL(
    new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" })
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = "betty-system.json";
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
